import { computed, ref, type ComputedRef, type Ref } from 'vue';
import type { CoberturaDetalle, CotizaTodasResponse } from '@/types/quote.types';
import { buildCoberturasPorPlan, getCoberturaKey } from './coverage';

export function useCoverageList(selectedQuotes: ComputedRef<CotizaTodasResponse | null>) {
  const mainCoberturas = computed(() => buildCoberturasPorPlan(selectedQuotes.value));
  const expandedCoberturaIds: Ref<Set<string>> = ref(new Set());

  const toggleCobertura = (cobertura: CoberturaDetalle): void => {
    const coberturaKey = getCoberturaKey(cobertura);
    const next = new Set(expandedCoberturaIds.value);
    next.has(coberturaKey) ? next.delete(coberturaKey) : next.add(coberturaKey);
    expandedCoberturaIds.value = next;
  };

  return { mainCoberturas, expandedCoberturaIds, toggleCobertura };
}
